const MAX_AGE_SECONDS_DELTA = 100
const MAX_AGE_SECONDS_MULTIPLIER = 0.8
const MAX_AGE_SECONDS_MIN = 10

const CSRF_HEADER_NAME = "X-Csrf-Token"

export {CSRF_HEADER_NAME, MAX_AGE_SECONDS_DELTA, MAX_AGE_SECONDS_MIN, MAX_AGE_SECONDS_MULTIPLIER}
